/* global lodalData */
const thankYouScreen = document.querySelector('section .purchase-process-05');

if (thankYouScreen && localData.id === '3106') {
  const cart = thankYouScreen.querySelector('.cart-view');
  const cartProducts = cart.querySelectorAll('.cart-view__product');
  const purchaseID = thankYouScreen.querySelector('#purchaseId').value;
  const revenue = thankYouScreen.querySelector('#revenue').value;
  const tax = thankYouScreen.querySelector('#tax').value;
  const shipping = thankYouScreen.querySelector('#shipping').value;
  const coupon = thankYouScreen.querySelector('#coupon').value;

  const products = [];
  cartProducts.forEach((product) => {
    const name = product.querySelector('#name').value;
    const brand = 'MebloJOGI';
    const id = product.querySelector('#id').value;
    const price = product.querySelector('#price').value;
    const category = product.querySelector('#category').value;
    const variant = JSON.parse(product.querySelector('#variant').value);
    const quantity = product.querySelector('#quantity').value;
    products.push({
      name,
      brand,
      id,
      price,
      category,
      variant,
      quantity,
    });
  });

  const gt4products = [];
  cartProducts.forEach((product) => {
    const name = product.querySelector('#name').value;
    const sku = product.querySelector('#sku').value;
    const price = product.querySelector('#price').value;
    const discount = product.querySelector('#discount').value;
    const category = product.querySelector('#category').value;
    const variant = JSON.parse(product.querySelector('#variant').value);
    const quantity = product.querySelector('#quantity').value;
    gt4products.push({
      item_id: sku,
      item_name: name,
      item_brand: 'MebloJOGI',
      affiliation: 'Online Store',
      discount,
      item_category: category,
      item_variant: variant,
      price,
      quantity,
    });
  });

  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'transaction',
    ecommerce: {
      purchase: {
        actionField: {
          id: purchaseID,
          affiliation: 'Online Store',
          revenue,
          tax,
          shipping,
          coupon,
        },
        products,
      },
    },
  });

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: purchaseID,
      value: revenue,
      tax,
      shipping,
      currency: 'EUR',
      coupon,
      affiliation: 'Online Store',
      items: gt4products,
    },
  });
}
